import { FIRST_MONTH_PROMOTION_CONFIRM } from '@/common/resources/const'
import { PROMOTION_100_CANCEL_SUBSCRIPTION_TICKET } from '@/common/util/voucher/const'
import { voucherModalManager } from '@/common/util/voucher/voucher-modal-manager'

export const handleUnsubscribe = () => {
  const { openModal, closeLayerPopup, waitForEvent } = voucherModalManager()

  const modal = {
    openPromotionNone: () =>
      openModal.promotion({
        title: PROMOTION_100_CANCEL_SUBSCRIPTION_TICKET.TITLE,
        description: PROMOTION_100_CANCEL_SUBSCRIPTION_TICKET.DESCRIPTION,
        confirmText: PROMOTION_100_CANCEL_SUBSCRIPTION_TICKET.CONFIRM_TEXT,
        component: () =>
          import('@/views/popup/popups/FirstMonthPromotionCancel.vue'),
      }),
  }

  /**
   * 모달 confirm success 유무를 프로미스로 리턴,
   * 리턴 전 로직이 필요 할 경우 callback (handler) 에서 처리
   * @returns {Promise<*>|Promise}
   */
  const waitForSuccessEvent = () => {
    return waitForEvent(FIRST_MONTH_PROMOTION_CONFIRM, (payload) => {
      if (!payload?.isSuccess) return false

      closeLayerPopup()
      return true
    })
  }

  return {
    modal,
    waitForSuccessEvent,
  }
}
